import axios from 'axios';

import { IRelativeTask, IUpdateRelatedTasksData } from 'src/models';
import { IRelativeTasksParams } from 'src/models/relativeTask';

export default {
    // 获取可关联回执列表
    getRelativeTasks(params: IRelativeTasksParams): Promise<IRelativeTask[]> {
        return axios.get<IRelativeTask[]>(`/api/audits/receipt-to-connect`, {
            params
        }).then(res => {
            return res.data;
        });
    },

    // 获取已关联回执列表
    getRelatedTasks(params: IRelativeTasksParams): Promise<IRelativeTask[]> {
        return axios.get<IRelativeTask[]>(`/api/audits/receipt-connected`, {
            params
        }).then(res => {
            return res.data;
        });
    },

    // 更新关联回执
    updateRelatedTasks(data: IUpdateRelatedTasksData): Promise<any> {
        return axios.post<any>(`/api/audits/receipt-connected`, data).then(res => {
            return res.data;
        });
    },
}
